import BasePins from './BasePins';

export default BasePins;
// Export images directly from the only component with images being used
export { images } from '../SelectedPin';
